const originalFetch = window.fetch;

window.fetch = async function(url, options, ...rest) {
  const response = await originalFetch.apply(this, [url, options, ...rest]);

  try {
    if (url.includes("https://forms.shopifyapps.com/api/v2/form_submission")) {
      let formId = "unknown";

      // Handle FormData
      if (options?.body instanceof FormData) {
        formId = options.body.get("form_instance_id") || formId;
      }

      // Handle JSON string
      if (options?.body && typeof options.body === "string") {
        try {
          const json = JSON.parse(options.body);
          formId = json.form_instance_id || formId;
        } catch {}
      }

      gtag("event", "form_submit", { form_id: formId });
      console.log("Form submission detected, form_id:", formId);
    }
  } catch (e) {
    console.error("Error detecting form submission", e);
  }

  return response;
};
